// public/js/features/settings/api-keys-api.js
// Thin wrappers around the customer API-key management endpoints. The plaintext
// key is returned ONLY by createApiKey (once). See docs/api-access.md.

async function jsonOrThrow(res) {
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { msg = (await res.json()).error || msg; } catch {}
    throw new Error(msg);
  }
  return res.json();
}

// GET /api/v1/api-keys[?tenantId=] → { keys[], scopes[] }
export async function listApiKeys(tenantId) {
  const q = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
  return jsonOrThrow(await window.authenticatedFetch(`api/v1/api-keys${q}`));
}

// POST /api/v1/api-keys → { key: '<plaintext once>', record }
export async function createApiKey({ label, scopes, tenantId }) {
  return jsonOrThrow(await window.authenticatedFetch('api/v1/api-keys', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ label, scopes, tenantId }),
  }));
}

// DELETE /api/v1/api-keys/:keyId[?tenantId=]
export async function revokeApiKey(keyId, tenantId) {
  const q = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
  return jsonOrThrow(await window.authenticatedFetch(`api/v1/api-keys/${encodeURIComponent(keyId)}${q}`, { method: 'DELETE' }));
}
